"use client";
import { useEffect, useState } from "react";

const GRAPHQL_API_URL = "https://production.api.lectrium.com/graphql";

const checkBadges = async (domain: string) => {
  try {
    const response = await fetch(GRAPHQL_API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query:
          "query GetEvSavingsBadgeByDomain($input: GetEvSavingsBadgeByDomainInput!) { ev_savings_badge_by_domain(input: $input) { id } }",
        variables: {
          input: {
            domain,
          },
        },
      }),
    });

    const data = await response.json();

    return !!data.data?.ev_savings_badge_by_domain;
  } catch (error) {
    console.error("Error fetching data:", error);
    return false;
  }
};

const checkListing = async (vin: string) => {
  const res = await fetch(`https://production.api.lectrium.com/integrations/listings/${vin}`);
  return res.status === 200;
};

const checkAvailability = async (vin: string, domain: string) => {
  const [listingsResponse, badgesResponse] = await Promise.all([checkListing(vin), checkBadges(domain)]);

  if (!listingsResponse || !badgesResponse) {
    throw new Error("No service data");
  }
};

type Props = {
  vin: string;
  domain: string;
};

const useCheckLectrum = ({ vin, domain }: Props) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    checkAvailability(vin, domain)
      .then(() => {
        setIsVisible(true);
      })
      .catch(() => {
        setIsVisible(false);
      });
  }, [vin, domain]);

  return isVisible;
};

export default useCheckLectrum;
